import { get } from 'src/api/api';
import { ENDPOINT_MICROSERVICE } from 'src/constants/api';

const DEFAULT_IP_INFO = {
  country: 'US',
  countryCode: 'US',
} as const;

export const getIpInfo = async (): Promise<{
  country: string;
  countryCode: string;
}> => {
  try {
    const ipInfoData = await get({
      endpoint: ENDPOINT_MICROSERVICE,
      path: 'ip_api',
    });

    return {
      country: ipInfoData.country,
      countryCode: ipInfoData.countryCode,
    };
  } catch (error) {
    console.warn('Failed to fetch IP info', error);
    return DEFAULT_IP_INFO;
  }
};
